import { render, staticRenderFns } from "./jumpsellerOrders.vue?vue&type=template&id=5c317cb3&scoped=true&"
import script from "./jumpsellerOrders.vue?vue&type=script&lang=js&"
export * from "./jumpsellerOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c317cb3",
  null
  
)

export default component.exports